import { useEffect } from "react";
import { Control, useFormContext, useWatch } from "react-hook-form";
import { FormUnitInput } from "../../../../../../components/ui/Input/FormUnitInput/FormUnitInput";
import { WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM } from "../../../../../../config/constants";
import { MEASUREMENT_TYPES } from "../../../../../../config/enums/MeasurementTypes";
import { cn } from "../../../../../../lib/utils";

import { validateCultivationNumber } from "../../../../../../utils/utils";

const UNIT_FIELD = "materialWeightUnit";

interface PackagingMaterialWeightInputProps {
  control: Control<any>;
  name: string;
  weightUnit: MEASUREMENT_TYPES;
  onUnitChange: (value: MEASUREMENT_TYPES) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  required?: boolean;
  errorMessage?: string;
}

const PackagingMaterialWeightInput = ({
  control,
  name,
  weightUnit,
  onUnitChange,
  disabled = false,
  placeholder = "0",
  className,
  required = false,
  errorMessage
}: PackagingMaterialWeightInputProps) => {
  const { setValue } = useFormContext();
  const watchedUnit = useWatch({ control, name: UNIT_FIELD });

  useEffect(() => {
    setValue(UNIT_FIELD, String(weightUnit));
  }, [weightUnit, setValue]);

  useEffect(() => {
    if (watchedUnit == null || watchedUnit === "") return;
    const numericUnit = Number(watchedUnit);
    if (!Number.isNaN(numericUnit) && numericUnit !== weightUnit) {
      onUnitChange(numericUnit as MEASUREMENT_TYPES);
    }
  }, [watchedUnit, weightUnit, onUnitChange]);

  return (
    <div className={cn("[&_label]:tw-hidden", className)}>
      <FormUnitInput
        control={control}
        name={name}
        label=""
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        errorMessage={errorMessage}
        min={0}
        enableLimitedDecimal
        validate={{
          valueCheck: (v: any) => validateCultivationNumber(v)
        }}
        unitName={UNIT_FIELD}
        unitOptions={WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM}
      />
    </div>
  );
};

export default PackagingMaterialWeightInput;
